module.exports = __webpack_public_path__ + "3e9253b2bc1015f71a31d3fd1995ff4e.svg";